import { render } from "./customerData.vue?vue&type=template&id=08398f52&scoped=true"
import script from "./customerData.vue?vue&type=script&lang=js"
export * from "./customerData.vue?vue&type=script&lang=js"

import "./customerData.vue?vue&type=style&index=0&id=08398f52&lang=less&scoped=true"

import exportComponent from "F:\\workspace\\clientapps\\Advertising-Platform\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08398f52"]])

export default __exports__